import { colors } from '@/lib/analytics/colors';
import { SIZE_25 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgEngagementRatePostConfig = {
    name: 'kpi.linkedin.avg_engagement_rate_post',
    id: 'average_engagement_rate_per_post',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: 'kpi.linkedin.tooltip_avg_engagement_rate_post',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
